import React from "react";

const AdminProfile = () => {
  return (
    <>
      <div className="rounded-full w-14 h-14 bg-admin-profile bg-cover relative left-2 md:-left-6">
        <div className="w-3 h-3 bg-green-600 rounded-full relative top-11 left-10">
          {" "}
        </div>{" "}
      </div>{" "}
    </>
  );
};

export default AdminProfile;
